'use strict';

import {addCustomEventListener, addClass, removeClass} from '../helpers';

export const homeSlider = (() => {
  let _slider;
  let _sliderNav;
  let _sliderBG;
  let _autoPlay;
  let sCurrent = 0;
  let sCount = 0;
  let timer = null;

  const setDots = () => {
    const _dotsWrap = _slider.querySelector('.home_slider__nav__dots');
    const _slides = _slider.querySelectorAll('.home_slider__slide');
    if (_slides.length) {
      sCount = _slides.length;
      let dotHtml = '';
      _slides.forEach((_el, i) => {
        _el.setAttribute('data-slide', i);
        dotHtml += `<button type="button" class="home_slider__nav__dot" data-slide="${i}">${i + 1}</button>`;
      });
      if (_dotsWrap && dotHtml !== '') {
        _dotsWrap.innerHTML = dotHtml;
      }
      setSlide(sCurrent);
      setBtnsClasses();
    }
  };

  const setBtnsClasses = () => {
    removeClass(_slider.querySelectorAll(`.home_slider__nav__dot[data-slide]`), 'active');
    const curDot = _slider.querySelector(`.home_slider__nav__dot[data-slide="${sCurrent}"]`);
    if (curDot) {
      addClass(curDot, 'active');
    }
  };

  const setSlide = (newNum) => {
    if (newNum < 0 || newNum >= sCount) {
      return false;
    }
    const _newCurrentSlide = _slider.querySelector(`.home_slider__slide[data-slide="${newNum}"]`);
    const bgColor = _newCurrentSlide.getAttribute('data-bg') || '#fff';
    removeClass(_slider.querySelectorAll(`.home_slider__slide`), 'active prev next');
    _sliderBG.style['background'] = bgColor;
    addClass(_newCurrentSlide, 'active');
    if (newNum - 1 >= 0) {
      addClass(_slider.querySelector(`.home_slider__slide[data-slide="${newNum - 1}"]`), 'prev');
    }
    if (newNum + 1 < sCount) {
      addClass(_slider.querySelector(`.home_slider__slide[data-slide="${newNum + 1}"]`), 'next');
    }
    sCurrent = newNum;
    setBtnsClasses();
    setTimeout(() => {
      autoPlay();
    }, 500);
  };

  const eventListeners = () => {
    addCustomEventListener('.home_slider__nav__btn', 'click', function (e) {
      const _btn = e.target;
      const type = _btn.getAttribute('data-type');
      const k = type === 'prev' ? -1 : 1;

      let newSlide = sCurrent + k;
      if (newSlide < 0) {
        newSlide = sCount - 1;
      }
      if (newSlide >= sCount) {
        newSlide = 0;
      }
      setSlide(newSlide)
    });
    addCustomEventListener('.home_slider__nav__dot', 'click', function (e) {
      const _btn = e.target;
      const newSlide = parseInt(_btn.getAttribute('data-slide'));

      setSlide(newSlide);
    });
  };

  const autoPlay = () => {
    if (!_autoPlay) return;
    const max = 125;
    let per = 0;
    clearInterval(timer);
    timer = setInterval(() => {
      const _svg = document.querySelector('.home_slider__auto-play__icon');
      const isTranslatedHtml = document.querySelector('html').classList.value.match(/translated-ltr|translated-rtl/);
      if (!window.shApp.homeSlideAutoplay || !_svg || isTranslatedHtml) return;
      _svg.setAttribute('stroke-dasharray', `${per},${max - per}`);
      per++;
      if (per > max) {
        clearInterval(timer);
        _slider.querySelector('.home_slider__nav__btn[data-type="next"]').click();
      }
    }, 50);
  };

  const init = () => {
    _slider = document.querySelector('.home_slider');
    _sliderNav = document.querySelector('.home_slider__nav');
    _sliderBG = document.querySelector('.home_slider__background');
    _autoPlay = document.querySelector('.home_slider__auto-play');
    if (!_slider) {
      return;
    }
    if (_slider.querySelectorAll('.home_slider__slide').length > 1) {
      eventListeners();
    } else {
      _sliderNav.remove();
      _autoPlay.remove();
    }
    setDots();
    addClass(_slider, 'is-loading');
  };

  return {
    init
  }
})();
